import React, { useState } from 'react';
import texture from '../../assets/images/illustration-inverse.png';

// Flaticon icons
import constructionIcon from '../../assets/icons/architect.png';
import modularIcon from '../../assets/icons/welding.png';
import containerIcon from '../../assets/icons/office.png';
import storageIcon from '../../assets/icons/warehouse.png';
import designIcon from '../../assets/icons/design.png';
import factoryIcon from '../../assets/icons/industrial.png';
import hospitalIcon from '../../assets/icons/building-construction.png';
import transportIcon from '../../assets/icons/bridge.png';
import turnkeyIcon from '../../assets/icons/safety.png';
import equipmentIcon from '../../assets/icons/tools.png';
import maintenanceIcon from '../../assets/icons/tool-box.png';
import financeIcon from '../../assets/icons/circular-economy.png';

export const AboutComponent = () => {
  const [activeService, setActiveService] = useState(null);
  const [cardSide, setCardSide] = useState('right');

  const services = [
    { name: "Engineered Constructions", icon: constructionIcon, description: "Executed: Industrial Plants\nIn Progress: Bridge Piling Project" },
    { name: "Modular Fabrications", icon: modularIcon, description: "Executed: Prefab Offices\nIn Progress: Prefab Quarters" },
    { name: "Containerized Structures", icon: containerIcon, description: "Executed: Portable Classrooms\nIn Progress: Mobile Clinics" },
    { name: "Bulk Material Storage Terminals", icon: storageIcon, description: "Executed: Cement Storage Facility\nIn Progress: Steel Yard Terminal" },
    { name: "Design & Execution Services", icon: designIcon, description: "Executed: Industrial Layout Design\nIn Progress: Smart Factory Layout" },
    { name: "Factory Infrastructure Development", icon: factoryIcon, description: "Executed: Assembly Lines\nIn Progress: Robotics Plant" },
    { name: "Hospital & Hotel Constructions", icon: hospitalIcon, description: "Executed: Luxury Hotel\nIn Progress: Community Hospital" },
    { name: "Roadway & Transportation Projects", icon: transportIcon, description: "Executed: State Highways\nIn Progress: Urban Metro Tracks" },
    { name: "Turnkey EPC Solutions", icon: turnkeyIcon, description: "Executed: Solar Power Plant\nIn Progress: Chemical Processing Unit" },
    { name: "Industrial Equipment Solutions", icon: equipmentIcon, description: "Executed: Conveyor Systems\nIn Progress: Water Purification Plant" },
    { name: "Maintenance Services", icon: maintenanceIcon, description: "Executed: Annual AMC\nIn Progress: Preventive Maint. Projects" },
    { name: "Financial Assistance", icon: financeIcon, description: "Executed: Project Loans\nIn Progress: Vendor Financing" },
  ];

  const column1 = services.slice(0, 4);
  const column2 = services.slice(4, 8);
  const column3 = services.slice(8, 12);

  const renderColumn = (items, columnIndex) => (
    <div className="flex flex-col space-y-4">
      {items.map((service, index) => (
        <div
          key={index}
          className="group flex items-start space-x-4 p-3 rounded-xl transition-transform duration-300 hover:bg-[#f0f8ff] hover:scale-[1.03] cursor-pointer"
          onMouseEnter={() => {
            setActiveService(service);
            setCardSide(columnIndex === 2 ? 'left' : 'right');
          }}
          onMouseLeave={() => setActiveService(null)}
        >
          <img
            src={service.icon}
            alt={`${service.name} icon`}
            className="w-10 h-10 mt-[2px] transition-transform duration-500"
          />
          <span className="text-[#7a7a7a] text-[18px] leading-[26px]">
            {service.name}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="relative w-full mx-auto flex items-center justify-center px-4 md:px-16 xl:px-24 3xl:px-36 py-[113px] max-w-[1920px] 3xl:max-w-[90%] 3xl:mx-auto">
      {/* Background */}
      <div
        className="absolute inset-0 w-full h-full bg-fixed bg-center bg-cover bg-no-repeat opacity-30 z-[-1]"
        style={{ backgroundImage: `url(${texture})` }}
        loading="lazy"
      />

      <div className="flex justify-between items-start w-full mx-auto">
        <div className="flex-1 p-4 lg:p-10">
          <div className="text-[#5bc0fe] text-left font-semibold text-[22px] lg:text-[24px] 3xl:text-[28px] mb-4">
            What We Do ?
          </div>
          <div className="text-[#404040] text-left font-black text-[32px] lg:text-[43px] 3xl:text-[52px] mb-6">
            Solutions We Have
          </div>

          <div className="text-[#7a7a7a] text-left text-[16px] lg:text-[18px] 3xl:text-[20px] mb-10 flex flex-col">
            <p className="mb-6">
              At LABH Industries, we offer world-class EPC, equipment solutions, and services across diverse industries...
            </p>
            <p className="mb-6">
              Our end-to-end solutions cover everything from design to execution...
            </p>

            {/* 3 Column Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 3xl:gap-x-20 gap-y-6 mt-4">
              {renderColumn(column1, 0)}
              {renderColumn(column2, 1)}
              {renderColumn(column3, 2)}
            </div>
          </div>
        </div>
      </div>

      {/* Hover Card */}
      {activeService && (
        <div
          className={`fixed top-20 h-[90%] w-[90%] md:w-1/2 max-w-[800px] bg-white shadow-2xl z-40 p-6 lg:p-10 transition-all duration-300 ease-in-out animate-fade-in ${
            cardSide === 'right' ? 'right-0' : 'left-0'
          } pointer-events-none`}
        >
          <div className="flex flex-col space-y-6">
            <div className="flex items-center space-x-6">
              <img src={activeService.icon} alt={activeService.name} className="w-14 h-14 3xl:w-16 3xl:h-16" />
              <h3 className="text-xl 3xl:text-3xl font-bold text-[#404040]">{activeService.name}</h3>
            </div>
            <div className="text-[#555] whitespace-pre-line text-[15px] lg:text-[16px] 3xl:text-[18px]">
              {activeService.description}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
